/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React from "react";

import {
  PlayPauseButton,
  PositionIndicator,
  SkipButton,
  Timeline,
  TimeMarker,
} from "./Component/Advertisement";
import { ToggleFullScreenButton, VolumeControl } from "./Component/Shared";

import "./Controller.scss";

export const AdController = () => {
  return (
    <div className="PlayerController">
      <div className="PlayerController__Above">
        <div className="PlayerController__Above__Left">
          <PositionIndicator />
        </div>
        <div className="PlayerController__Above__Center" />
        <div className="PlayerController__Above__Right">
          <SkipButton />
        </div>
      </div>
      <div className="PlayerController__Timeline">
        <div className="PlayerController__Timeline__Progress">
          <Timeline />
        </div>
        <div className="PlayerController__Timeline__Marker">
          <TimeMarker />
        </div>
      </div>
      <div className="PlayerController__Buttons">
        <div className="PlayerController__Buttons__Left">
          <PlayPauseButton />
          <VolumeControl />
        </div>
        <div className="PlayerController__Buttons__Center"></div>
        <div className="PlayerController__Buttons__Right">
          <ToggleFullScreenButton />
        </div>
      </div>
    </div>
  );
};
